const style = (theme) => {
  const output = {
    root: {
      lineHeight: 1,
      display: 'inline-block',
      margin: 0,
      position: 'relative',
      '& span': {
        transition: 'all 0.2s',
      },
      '& svg': {
        pointerEvents: 'none',
        width: '100%',
        position: 'absolute',
        zIndex: 1,
        left: 0,
        bottom: (props) => -props.height * 0.83,
        '& path': {
          width: '100%',
          stroke: theme.colors[3],
        },
      },
      '@media (hover: hover)': {
        '&:hover': {
          '&:hover': {
            '& span': {
              color: theme.colors[3],
            },
          },
        },
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
